import React from 'react';
import {
  CAR_NUMBER,
  MOTORCYCLE_NUMBER,
  BUS_NUMBER,
  CARGO_VEHICLE_NUMBER,
  NAUTICAL_VEHICLE_NUMBER,
  AGRICULTURAL_VEHICLE_NUMBER,
  PARTS_NUMBER,
} from '../../../../utils/productType';
import {
  CarDatasheet,
  MotorcycleDatasheet,
  TruckDatasheet,
  BusDatasheet,
  NauticDatasheet,
  AgrarianDatasheet,
  ProductDatasheet,
} from '../components/Datasheets';

export const getInfo = (type: any, data: any) => {
  switch (Number(type)) {
    case CAR_NUMBER:
      return <CarDatasheet data={data} />;
    case MOTORCYCLE_NUMBER:
      return <MotorcycleDatasheet data={data} />;
    case BUS_NUMBER:
      return <BusDatasheet data={data} />;
    case CARGO_VEHICLE_NUMBER:
      return <TruckDatasheet data={data} />;
    case NAUTICAL_VEHICLE_NUMBER:
      return <NauticDatasheet data={data} />;
    case AGRICULTURAL_VEHICLE_NUMBER:
      return <AgrarianDatasheet data={data} />;
    case PARTS_NUMBER:
      return <ProductDatasheet {...data} />;
  }
};

export const vehicleDescription = (type: any) => {
  switch (Number(type)) {
    case CAR_NUMBER:
      return 'o carro';
    case MOTORCYCLE_NUMBER:
      return 'a moto';
    case BUS_NUMBER:
      return 'o ônibus';
    case CARGO_VEHICLE_NUMBER:
      return 'o veículo';
    case NAUTICAL_VEHICLE_NUMBER:
      return 'a náutica';
    case AGRICULTURAL_VEHICLE_NUMBER:
      return 'a agrícola';
  }
};
